class ClaimLeaveData {
    formatClaimGroup = (claim) => {
        const agreementId =
            claim.groupAgreementId ??
            claim.groupAgreementID ??
            claim.coverageDetail?.groupAgreementID ??
            claim.coverageDetail?.groupAgreementId;
        const divisionId = claim.divisionId ?? claim.coverageDetail?.divisionId;

        return [agreementId, divisionId]
            .filter(
                (value) => value !== null && value !== undefined && value !== ""
            )
            .join(" - ");
    };

    format = (response) => {
        const claimLeaveData = [];

        if (response.ClaimLeaveData && Array.isArray(response.ClaimLeaveData)) {
            response.ClaimLeaveData.forEach((d) => {
                if (d.ClaimData && d.ClaimData.ClaimNo) {
                    claimLeaveData.push({
                        ...d.ClaimData,
                        isClaim: true,
                        Historical: false,
                        No: d.ClaimData.ClaimNo,
                        StartDate: d.ClaimData.ClaimStartDate,
                        EndDate: d.ClaimData.ClaimEndDate,
                        Group: d.ClaimData.PolicyDiv,
                        MaximumDuration: d.ClaimData.ClaimMaxDuration,
                        StatusReason: d.ClaimData.ClaimStatusReason,
                        LeaveReason: d.ClaimData.DiagnosticDescription,
                    });
                }

                if (d.LeaveData && d.LeaveData.LeaveNo) {
                    claimLeaveData.push({
                        ...d.LeaveData,
                        isClaim: false,
                        No: d.LeaveData.LeaveNo,
                        StartDate: d.LeaveData.LeaveStartDate,
                        EndDate: d.LeaveData.LeaveEndDate,
                        Group: d.LeaveData.ReportGroup,
                        MaximumDuration: d.LeaveData.LeaveMaxDuration,
                        StatusReason: d.LeaveData.LeaveStatusReason,
                        Disability: null,
                        Historical: d.LeaveData.LeaveHistoricalIND === "Y",
                    });
                }
            });
        }

        return claimLeaveData;
    };

    formatOds = (rawEmployee) => {
        if (!rawEmployee) return [];

        const claims = rawEmployee.claim || [];
        const leaves = rawEmployee.leave || [];

        return [
            ...claims.map((claim) => ({
                isClaim: true,
                Historical: false,
                No: claim.claimId,
                Coverage: claim.coverageType,
                CurrentStatus: claim.derivedClaimStatusDesc,
                StatusReason:
                    claim.customClaimStatusReason ||
                    claim.customClaimStatusReasonDesc,
                LeaveReason: claim.primaryDiagnosisDesc,
                StartDate: claim.claimBenefitBeginDt || claim.disabilityBeginDt,
                EndDate: claim.claimApprovedThruDt || claim.claimBenefitEndDt,
                Group: this.formatClaimGroup(claim),
                MaximumDuration: claim.claimBenefitEndDt,
                RTWStatus: claim.rtwStatusDesc,
                RTWDate: claim.fullTimeRtwDt,
                Disability: claim.disabilityBeginDt,
                ReceivedDate: claim.claimReceivedTs,
                LastWorkDate: claim.lastWorkedDt,
                CurrentStatusDate: claim.claimStatusEffectiveDt,
                OrganizationId: claim.srcOrgDetails?.orgId || rawEmployee.orgId,
            })),
            ...leaves.map((leave) => ({
                isClaim: false,
                Historical: leave.historicalLeaveInd === "Y",
                LeaveHistoricalIND: leave.historicalLeaveInd,
                No: leave.leaveId,
                Coverage: leave.leaveCoverageTypeDesc || leave.coverageType,
                CurrentStatus: leave.leaveStatus,
                StatusReason: leave.leaveCloseReason,
                LeaveReason: leave.leaveReasonDesc || leave.leaveReason,
                StartDate: leave.leaveStartDt,
                EndDate: leave.leaveEndDt,
                Group: leave.reportGroupName,
                MaximumDuration: null,
                RTWStatus: leave.rtwstatus || leave.RTWStatus,
                RTWDate: leave.rtwdt || leave.RTWDt,
                Disability: null,
                ReceivedDate: leave.leaveReceivedDt,
                LastWorkDate: leave.lastDateWorked,
                CurrentStatusDate: leave.leaveStatusEffectiveDt,
                OrganizationId: leave.srcOrgDetails?.orgId || rawEmployee.orgId,
            })),
        ];
    };
}

export default new ClaimLeaveData();
